import dayjs from 'dayjs';

/** When a coupling began or ended, as the couple drawer's own picker writes it. */
export function formatCouplingTime(iso: string): string {
  return dayjs(iso).format('D MMM YYYY, HH:mm');
}

/** What the history's "Dropped at" column says: the zone, or why there is none. */
export function dropPlaceLabel(coupling: { uncoupledAt: string | null; dropZoneCode: string | null; dropZoneName: string | null }): string {
  if (!coupling.uncoupledAt) return '—';
  if (!coupling.dropZoneCode) return 'Moved to another truck';
  return coupling.dropZoneName ?? coupling.dropZoneCode;
}

/** Shown before a couple or uncouple when the truck is out: the trip keeps the trailer it set off with (gitaumoses4/chukua#390). */
export function tripNotice(truck: { registration: string; status: string } | null): string | undefined {
  if (truck?.status !== 'on_trip') return undefined;
  return `${truck.registration} is on a trip. The trip keeps the trailer it set off with; this change applies from its next trip.`;
}
